import ThisModule from "./Banner";

export default ThisModule;
